<template>
  <div class="tt-encrypt-code" @click="focus">
    <input
      ref="input"
      v-model="password"
      class="encrypt-input"
      type="number"
      autocomplete="new-password"
      required
      autofocus
      :maxlength="length"
      v-bind="$attrs"
    />
    <div :class="encryptCls">
      <span
        v-for="index in lengthArr"
        :key="index"
        :class="{
          'encrypt-cell': true,
          show: index <= password.length,
          active: password.length + 1 === index
        }"
      >
        {{ showType === 'password' ? '&#8226;' : password[index - 1] }}</span
      >
    </div>
  </div>
</template>
<script>
import broadcastMixin from 'mixins/broadcastMixin'
export default {
  name: 'EncryptCode',
  mixins: [broadcastMixin],
  props: {
    autoFocus: {
      type: Boolean,
      default: false
    },
    length: {
      type: Number,
      default: 6
    },
    showType: {
      type: String,
      default: 'password'
    },
    value: String,
    type: {
      type: 'box' | 'underline',
      default: 'box'
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    value(val) {
      this.password = val
    },
    password(psw) {
      const str = psw.slice(0, this.length)
      this.password = str
      if (str !== this.value) {
        this.$emit('change', str)
      }
      if (str.length === this.length) {
        this.$emit('done', str)
      }
    }
  },
  data() {
    return {
      password: ''
    }
  },
  mounted() {
    if (this.autoFocus) {
      setTimeout(() => {
        this.focus()
      }, 0)
    }
  },
  computed: {
    lengthArr() {
      const arr = []
      for (let i = 0; i < this.length; i++) {
        arr.push(i + 1)
      }
      return arr
    },
    encryptCls() {
      return {
        'encrypt-box': true,
        [`encrypt-type--${this.type}`]: !!this.type
      }
    }
  },
  methods: {
    focus() {
      const target = this.$refs.input
      target && target.focus()
    },
    blur() {
      const target = this.$refs.input
      target && target.blur()
    }
  }
}
</script>
<style lang="less" type="text/less">
@import '~uikit';
.tt-encrypt-code {
  position: relative;
  display: inline-block;

  .encrypt-input {
    padding: 0;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;
    opacity: 0;
  }

  .encrypt-box {
    display: flex;
    align-items: center;
    &.encrypt-type--box {
      .encrypt-cell {
        border: 1px solid #e1e6f0;
      }
    }
    &.encrypt-type--underline {
      .encrypt-cell {
        border: none;
        margin: 0 3px;
        border-bottom: 1px solid #a0aaaf;
      }
    }
    .encrypt-cell {
      position: relative;
      width: 40px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      background-color: #fff;
      color: #fff;
      text-align: center;
      &.show {
        color: #222;
      }

      &:not(:last-child) {
        border-right: none;
      }

      &:first-of-type {
        border-radius: 2px 0 0 2px;
      }

      &:last-of-type {
        border-radius: 0 2px 2px 0;
      }
    }
  }
  .encrypt-input:focus + .encrypt-box {
    .active:after {
      content: '';
      position: absolute;
      left: 20px;
      top: 10px;
      height: 20px;
      border-left: solid 1px @black;
      animation: blink 800ms linear infinite;
    }
  }
}
@keyframes blink {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
